const translation = {
    errors: {
        server_error: "Something going wrong. Try again later.",
        connection_error:
            "You are not connected to the internet, please check you'r connection",
        credentials_error: "Incorrect reservation id or email/phone",
        timeout_error: "Your request timed out, please try again later"
    },
    common: {
        months: {
            jan: "January",
            feb: "February",
            mar: "March",
            apr: "April",
            may: "May",
            jun: "June",
            jul: "July",
            aug: "August",
            sep: "September",
            oct: "October",
            nov: "November",
            dec: "December"
        }
    },
    login: {
        submit_button: "Login",
        booking_reference: "Reservation ID",
        email_or_phone: "Email Address or Phone Number"
    },
    knowledge: {
        title: "Knowledge",
        search: {
            title: "Search",
            terms_example: "Search results for: {terms}"
        }
    },
    form: {
        prev: "Prev",
        next: "Next",
        submit: "Submit"
    },
    components: {
        current_reservation: {
            current: "Current",
            checkin: "Checkin",
            checkout: "Checkout",
            empty: "No Current Reservation",
            view_button: "View my reservations",
            manage_button: "Manage my reservations"
        },
        profile_view: {
            block_name: "Profile",
            manage_button: "Manage my profile"
        },
        profile_edit: {
            block_name: "Profile",
            title_label: "Title",
            title_options: ["Mr", "Ms", "Mx", "Miss", "Mrs"],
            first_name_label: "First name",
            last_name_label: "Last name",
            success_message: "Profile saved",
            save_button: "Save"
        },
        consents_view: {
            block_name: "Consents",
            empty: "You Don't Have Granted Consents",
            manage_button: "Manage my consents"
        },
        consents_edit: {
            block_name: "Consents",
            success_message: "Consents saved",
            save_button: "Save"
        },
        emails_edit: {
            block_name: "Emails",
            success_message: "Email saved",
            add_new_button: "Add new email address",
            created_message: "New email created",
            deleted_message: "Email deleted",
            primary_updated_message: "Primary email changed",
            modal: {
                block_name: "Add new email address",
                address_label: "Email Address",
                primary_label: "Make this email primary",
                save_button: "Save",
                cancel_button: "Cancel"
            }
        },
        phones_edit: {
            block_name: "Phones",
            success_message: "Phone saved",
            add_new_button: "Add new phone number",
            created_message: "New phone created",
            deleted_message: "Phone deleted",
            primary_updated_message: "Primary phone changed",
            modal: {
                block_name: "Add new phone number",
                number_label: "Phone Number",
                primary_label: "Make this phone primary",
                save_button: "Save",
                cancel_button: "Cancel"
            }
        }
    }
};

export default translation;
